import React, {useState, useLayoutEffect, useEffect} from 'react'
import {CommonFieldsJson,CommonFieldsCategories} from './ControlEntries'
import style from './CommonFieldsLayout.module.css'
import { useTranslation } from 'react-i18next';
import {Row, Container, Col} from 'react-bootstrap'
import Zoom from '@material-ui/core/Zoom';
import {useSelector} from "../../../Redux"
import { GetStateFromData } from '../../CustomHooks/CustomHooks';


const CommonFieldsLayout = (props) => {
    const { t } = useTranslation(); 

    const contexts = GetStateFromData();
	
    const {openDrawer, setOpenDrawer, drawerPinned,openCanvasForSubform } = contexts.contexts;
    const [nonDraggableElements , setNonDraggableElements ] = useState([]);
    const formData = props.formData;

    useEffect(() => {
        const isMenu = formData?.containerControl === "Menu";
    
        const isWizard =
          formData?.containerControl === "wizard_v" ||
          formData?.containerControl === "sidenavigation" ||
          formData?.containerControl === "wizard_h";
    
        if (isMenu || isWizard) {
          setNonDraggableElements((prev) => [...prev, "tab"]);
        } else {
            const copyNonDraggableElements= [...nonDraggableElements];
            const index = copyNonDraggableElements.indexOf("tab");
            if (index > -1) {
              copyNonDraggableElements.splice(index, 1);
            }
            setNonDraggableElements(copyNonDraggableElements);
        }
      }, [formData.containerControl, formData.formId]);

    try {
      if (
        formData &&
        formData["children"] &&
        formData["children"].length > 0 &&
        formData["id"] === "FormDef"
      ) {
        for (let i = 0; i < formData["children"].length; i++) {
          if (
            formData["children"][i] &&
            formData["children"][i]["id"] &&
            formData["children"][i]["id"] === "RootControl"
          ) {
            if (
              formData["children"][i]["children"] &&
              formData["children"][i]["children"].length > 0
            ) {
              for (
                let j = 0;
                j < formData["children"][i]["children"].length;
                j++
              ) {
                if (
                  formData["children"][i]["children"][j]["id"] &&
                  formData["children"][i]["children"][j]["id"] !== "Event"
                ) {
                    if (!nonDraggableElements.includes("wizard_h")) {
                        setNonDraggableElements([
                          ...nonDraggableElements,
                          "wizard_h"
                        ]);
                    } 
                    else if (!nonDraggableElements.includes("wizard_v")) {
                      setNonDraggableElements([
                        ...nonDraggableElements,
                        "wizard_v"
                      ]);
                    }
                    else if (!nonDraggableElements.includes("Menu")) {
                        setNonDraggableElements([
                          ...nonDraggableElements,
                          "Menu"
                        ]);
                    }
                    else if (!nonDraggableElements.includes("sidenavigation")) {
                        setNonDraggableElements([
                          ...nonDraggableElements,
                          "sidenavigation"
                        ]);
                    }
                }
              }
              if(formData["children"][i]["children"].length===1 && formData["children"][i]["children"][0]['id'] && formData["children"][i]["children"][0]['id']==='Event'){
                var tempNonDraggableElements = nonDraggableElements;
                if(tempNonDraggableElements.includes('wizard_h')){
                    let index = tempNonDraggableElements.indexOf('wizard_h');
                    tempNonDraggableElements.splice(index,1);
                }
                if (tempNonDraggableElements.includes("wizard_v")) {
                let index = tempNonDraggableElements.indexOf("wizard_v");
                delete tempNonDraggableElements.splice(index, 1);
                }
                if (tempNonDraggableElements.includes("Menu")) {
                    let index = tempNonDraggableElements.indexOf("Menu");
                    delete tempNonDraggableElements.splice(index, 1);
                }
                if (tempNonDraggableElements.includes("sidenavigation")) {
                    let index = tempNonDraggableElements.indexOf("sidenavigation");
                    delete tempNonDraggableElements.splice(index, 1);
                }
              }
            }
          }
        }
      }
    } 
    catch (err) {
      // console.error(err);
    }
    
    function closeDrawerWhileDraggingAndNotPinned(){
        // console.log("dragging closeDrawerWhileDraggingAndNotPinned",'| drawerPinned :: ',drawerPinned,'|openDrawer :: ',openDrawer);
        if(drawerPinned===false){
            if(openDrawer===true){
                // console.log('dragging :: openDrawer :: ',openDrawer);
                // setOpenDrawer(false);
            }
        }
    }

    useLayoutEffect(() => {
        var allControlDivWrappers = document.getElementsByClassName("getThisControlDivWrapper");
        for(let i=0;i<allControlDivWrappers.length ; i++){
            ////console.log('allControlDivWrappers['+i+'].childNodes :: ',allControlDivWrappers[i].childNodes);
            if(allControlDivWrappers[i].childNodes[1]){
                let controlIconWrapper = allControlDivWrappers[i].childNodes[0];
                var controlIcon;
                if(controlIconWrapper && controlIconWrapper.childNodes[0]){
                    controlIcon = controlIconWrapper && controlIconWrapper.childNodes[0];
                }
                let controlNameDiv = allControlDivWrappers[i].childNodes[1];
                if(controlNameDiv.childNodes[0]){
                    let controlNameLabel = controlNameDiv.childNodes[0];
                    if(controlNameLabel.innerHTML){
                        var controlNameLength = controlNameLabel.innerHTML.length;
                        if(controlNameLength>11){
                            ////console.log('controlIcon :: ',controlIcon);
                            controlIcon.style.marginBottom = "2px";
                        }
                    }
                }
            }
        }
        
    });
    let CommonFields = [] 
    if(openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform"){
        CommonFields =  [...CommonFieldsJson['Common Fields']];
        CommonFields.pop()
    }else{
        CommonFields =  [...CommonFieldsJson['Common Fields']]
    }
    return (
        <div className={style.allControlsWrapper}>
            {
                CommonFieldsCategories.map(
                    (categoryName , index) => {
                        return (
                            <div className={style.categoryWrapper}>
                                <Container fluid>
                                    <div className={style.categorylabel}>
                                        {t(categoryName)}
                                    </div>
                                    <Row xs={3} md={3} lg={3} className={style.controlGroupWrapper}>
                                        {  
                                            CommonFields.map(
                                                control => {
                                                    if (!props.search || (props.search && control.label.toLowerCase().includes(props.search.toLowerCase()))){
                                                    var controlIcon = control['icon'];
                                                    var controlLabel = control['label'];
                                                    var controlElemType = control['elem_type'];
                                                    
                                                    if(nonDraggableElements.includes(controlElemType)){
                                                        return (
                                                            <Zoom in={true}>
                                                                <Col 
                                                                    className={style.nonDraggableElement}  
                                                                    inptype={controlElemType} 
                                                                    draggable="false"
                                                                >
                                                                    <div 
                                                                        className={style.ControlsWrapperNonDraggable + ' getThisControlDivWrapper'} 
                                                                        inptype={controlElemType} 
                                                                    >
                                                                        <div className={style.IconWrapper}>
                                                                            {controlIcon? <div className={style.iconDiv} >{controlIcon}</div> : <div className={style.squareIcon} />}
                                                                        </div>
                                                                        <div className={style.controlName + ' controlNameDiv'}>
                                                                            <div className={style.controlLabel+' controlNameLabel'}>
                                                                                {t(controlLabel)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Zoom>
                                                        );
                                                    } 
                                                    else {
                                                        return (
                                                            <Zoom in={true}>
                                                                <Col 
                                                                    className={style.customCol}  
                                                                    style={{maxWidth: "50%"}}
                                                                    inptype={controlElemType} 
                                                                    onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                    onDragStart={props.createNewElement} 
                                                                    draggable="true" 
                                                                >
                                                                    <div 
                                                                        className={style.ControlsWrapper + ' getThisControlDivWrapper'} 
                                                                        tabIndex={0}
                                                                        onDragStart={props.createNewElement} 
                                                                        draggable="true" 
                                                                        inptype={controlElemType} 
                                                                        onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                    >
                                                                        <div className={style.IconWrapper}                                                                         onDragStart={props.createNewElement} 
                                                                        draggable="true" 
                                                                        inptype={controlElemType} 
                                                                        onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                        >
                                                                            {controlIcon? <div className={style.iconDiv} 
                                                                            onDragStart={props.createNewElement} 
                                                                            draggable="true" 
                                                                            inptype={controlElemType} 
                                                                            onDrag={closeDrawerWhileDraggingAndNotPinned}                                                                             
                                                                            >{controlIcon}</div> : <div className={style.squareIcon} 
                                                                            onDragStart={props.createNewElement} 
                                                                            draggable="true" 
                                                                            inptype={controlElemType} 
                                                                            onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                            />}
                                                                        </div>
                                                                        <div className={style.controlName + ' controlNameDiv'}
                                                                        onDragStart={props.createNewElement} 
                                                                        draggable="true" 
                                                                        inptype={controlElemType} 
                                                                        onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                        >
                                                                            <div className={style.controlLabel+' controlNameLabel'}
                                                                            onDragStart={props.createNewElement} 
                                                                            draggable="true" 
                                                                            inptype={controlElemType} 
                                                                            onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                            >
                                                                                {t(controlLabel)}

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Zoom>
                                                        )
                                                    }   
                                                }  
                                            }                                                  
                                            )
                                        }
                                    </Row>
                                </Container>                                
                            </div>
                        );
                        
                    }
                )
            }
           
        </div>
    )
}

export default CommonFieldsLayout;
